export const AVAILABLE_FONTS = [
    {
        id: "default",
        name: "Default",
        fontFamily: '"Open Sans", sans-serif',
    },
    {
        id: "modern",
        name: "Modern",
        fontFamily: '"Figtree", sans-serif',
    },
    {
        id: "classic",
        name: "Classic",
        fontFamily: '"EB Garamond", serif',
    },
    {
        id: "bold",
        name: "Bold",
        fontFamily: '"Fahkwang", sans-serif',
    },
    {
        id: "elegant",
        name: "Elegant",
        fontFamily: '"Forum", serif',
    },
];

export const getFontFamily = (fontId) => {
    const font = AVAILABLE_FONTS.find(f => f.id === fontId);
    return font ? font.fontFamily : AVAILABLE_FONTS[0].fontFamily;
};
